/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */
import { isExsit } from '@/apis/user'

export const validateUsername = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入用户名'))
  }
  const flag = new RegExp(/^([A-Z\a-z\u4e00-\u9fa5\d]+?)$/).test(value)
  if (!flag) {
    callback(new Error('用户名支持小写英文、数字、中文'))
  }
  isExsit({ username: value }).then(response => {
    if (window.boxType === 'edit') callback()
    const result = response.data.data
    if (result) {
      return callback(new Error('用户名已经存在'))
    } else {
      return callback()
    }
  })
}

// 设置密码校验规则
export const checkPassword = (rule, value, callback) => {
  if (window.boxType === 'edit') {
    return callback()
  }
  if (!value) {
    callback(new Error('请输入密码'))
  } else if (value.length <= 6) {
    callback(new Error('请输入6位以上密码'))
  } else {
    callback()
  }
}

// 设置手机号的验证规则
export const checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入联系方式'))
  } else {
    const reg = /^1[3-9]\d{9}$/
    if (!reg.test(value)) {
      return callback(new Error('请输入正确的电话'))
    }
  }

  isExsit({ phone: value }).then(response => {
    if (window.boxType === 'edit') callback()
    const result = response.data.data
    debugger
    if (result) {
      return callback(new Error('手机号已经存在'))
    } else {
      return callback()
    }
  })
}
